'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('slider-editor', {
      url: '/admin/slider-editor',
      template: '<slider-editor></slider-editor>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/slider/slider-editor.routes.js